function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "reports-icon",
  transform: "translate(-518.233 -258.379)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_391",
  "data-name": "Ret\\xE2ngulo 391",
  width: 31.912,
  height: 40.5,
  transform: "translate(518.233 265.13)",
  fill: "#c6c6c6"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_392",
  "data-name": "Ret\\xE2ngulo 392",
  width: 32.661,
  height: 40.499,
  transform: "translate(523.142 262.88)",
  fill: "#e2e2e2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_393",
  "data-name": "Ret\\xE2ngulo 393",
  width: 33.411,
  height: 40.5,
  transform: "translate(528.05 260.629)",
  fill: "#c6c6c6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4439",
  "data-name": "Caminho 4439",
  d: "M561.261,258.379h-28.3v40.5h33.274V263.352h-4.972Z",
  fill: "#e2e2e2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4440",
  "data-name": "Caminho 4440",
  d: "M561.261,263.352h4.972l-4.972-4.973Z",
  fill: "#c6c6c6"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_394",
  "data-name": "Ret\\xE2ngulo 394",
  width: 15.748,
  height: 1.5,
  transform: "translate(536.846 263.1)",
  fill: "#db5743"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_395",
  "data-name": "Ret\\xE2ngulo 395",
  width: 15.749,
  height: 1.5,
  transform: "translate(546.597 267.6)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_396",
  "data-name": "Ret\\xE2ngulo 396",
  width: 6.748,
  height: 1.5,
  transform: "translate(536.846 267.6)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_397",
  "data-name": "Ret\\xE2ngulo 397",
  width: 6.748,
  height: 1.5,
  transform: "translate(551.848 272.101)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_398",
  "data-name": "Ret\\xE2ngulo 398",
  width: 11.998,
  height: 1.5,
  transform: "translate(536.846 272.101)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_399",
  "data-name": "Ret\\xE2ngulo 399",
  width: 13.499,
  height: 1.5,
  transform: "translate(541.346 276.602)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_400",
  "data-name": "Ret\\xE2ngulo 400",
  width: 2.248,
  height: 1.5,
  transform: "translate(536.846 276.602)",
  fill: "#7a8e9b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_401",
  "data-name": "Ret\\xE2ngulo 401",
  width: 13.499,
  height: 1.5,
  transform: "translate(541.346 281.102)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_402",
  "data-name": "Ret\\xE2ngulo 402",
  width: 2.248,
  height: 1.5,
  transform: "translate(536.846 281.102)",
  fill: "#7a8e9b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_403",
  "data-name": "Ret\\xE2ngulo 403",
  width: 10.498,
  height: 1.5,
  transform: "translate(541.346 285.602)",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_404",
  "data-name": "Ret\\xE2ngulo 404",
  width: 2.248,
  height: 1.5,
  transform: "translate(536.846 285.602)",
  fill: "#7a8e9b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4441",
  "data-name": "Caminho 4441",
  d: "M562.241,283.617a2.448,2.448,0,0,0-2.7-2.515c-1.068,0-1.192-.579-1.192-1.016a1.115,1.115,0,0,1,1.192-1.013,1.2,1.2,0,0,1,1.123.675.75.75,0,1,0,1.383-.582,2.608,2.608,0,0,0-1.756-1.492v-.322a.75.75,0,1,0-1.5,0v.332a2.543,2.543,0,0,0-1.942,2.4,2.444,2.444,0,0,0,2.692,2.516c1.075,0,1.2.579,1.2,1.015a1.117,1.117,0,0,1-1.193,1.015,1.2,1.2,0,0,1-1.123-.676.75.75,0,1,0-1.383.582,2.611,2.611,0,0,0,1.749,1.491v.323a.75.75,0,0,0,1.5,0v-.33A2.543,2.543,0,0,0,562.241,283.617Z",
  fill: "#525c6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4442",
  "data-name": "Caminho 4442",
  d: "M536.847,296.709a.75.75,0,0,1-.407-1.381l3.791-2.438a.739.739,0,0,1,.51-.112l4.454.623,5.041-2.55a.753.753,0,0,1,.528-.057l4.949,1.3,5.4-3.155a.75.75,0,0,1,.758,1.295l-5.667,3.312a.761.761,0,0,1-.57.078l-4.974-1.3-5,2.528a.739.739,0,0,1-.443.073l-4.412-.617-3.556,2.286A.747.747,0,0,1,536.847,296.709Z",
  fill: "#7a8e9b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_88",
  "data-name": "Elipse 88",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(539.218 292.083)",
  fill: "#ffbd66"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_89",
  "data-name": "Elipse 89",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(543.718 292.599)",
  fill: "#f87670"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_90",
  "data-name": "Elipse 90",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(549.109 290.208)",
  fill: "#ffbd66"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_91",
  "data-name": "Elipse 91",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(554.265 291.24)",
  fill: "#f87670"
}));

var SvgReportsIcon = function SvgReportsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47.251,
    viewBox: "0 0 48 47.251",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports-icon.ff02a7c2.svg";
export { ForwardRef as ReactComponent };